import { render, staticRenderFns } from "./FinYearStatistics.vue?vue&type=template&id=60627c44&scoped=true&"
import script from "./FinYearStatistics.vue?vue&type=script&lang=js&"
export * from "./FinYearStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60627c44",
  null
  
)

export default component.exports